"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
var Types;
(function (Types) {
    Types["H1"] = "h1";
    Types["H2"] = "h2";
    Types["H3"] = "h3";
    Types["H4"] = "h4";
    Types["H5"] = "h5";
    Types["H6"] = "h6";
})(Types = exports.Types || (exports.Types = {}));
//# sourceMappingURL=HeadingProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Heading/HeadingProps.js
// module id = 433
// module chunks = 8